import React, { useState, useEffect } from "react";
import {
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  Label,
  Form,
  Button,
  Container,
  Row,
  Col,
  Table,
  Alert,
  Spinner,
} from "reactstrap";
import * as FaIcons from "react-icons/fa";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import logos from "../../components/img/base/111.png";
import logos2 from "../../Pages/Admin/documentos/convocatoria/logo.jpeg";
import DefaultProfileImage from "../../components/img/base/Default.png"; // <-- Importa la imagen
import axios from "axios";
import "../Bec/bec.scss";
import Swal from "sweetalert2";

function ListUserPost() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [dataP, setDataP] = useState([]);
  const [modalInsertar, setModalInsertar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({
    id: "",
    imagen_post: "",
    nombre_post: "",
    apellido_post: "",
    ci_bec_post: "",
    email_post: "",
    reg_estud_post: "",
    instsup_post: "",
    fac_inst_post: "",
    dirinst_post: "",
    totsemanio_post: "",
    semanioing_post: "",
    tipinst_post: "",
    tipcarr_post: "",
    depainst_post: "",
    provinst_post: "",
    locainst_post: "",
    carr_post: "",
    semcurs_post: "",
    nom_pad_post: "",
    ci_pad_post: "",
    tel_pad_post: "",
    ciu_pad_post: "",
    prov_pad_post: "",
    loc_pad_post: "",
    ocu_pad_post: "",
    nom_mad_post: "",
    ci_mad_post: "",
    tel_mad_post: "",
    ciu_mad_post: "",
    prov_mad_post: "",
    loc_mad_post: "",
    ocu_mad_post: "",
    bec_sino_post: "",
    tipo_bec_post: "",
    lug_bec_post: "",
    preg_cinco_post: "",
    preg_seis_post: "",
    preg_siete_post: "",
    preg_ocho_post: "",
    preg_nueve_post: "",
    preg_diez_post: "",
    lug_post: "",
    fec_post: "",
  });
  // Definir un objeto de validación con patrones de expresiones regulares y estados de validación iniciales
  const validation = {
    nombre_post: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    apellido_post: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    ci_bec_post: { regex: /^\d{6,12}$/, isValid: true },
    carr_post: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,30}$/,
      isValid: true,
    },
    instsup_post: { regex: /^[a-zA-Z\s]{1,30}$/, isValid: true },
    dirinst_post: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,50}$/,
      isValid: true,
    },
    depainst_post: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,100}$/,
      isValid: true,
    },
    nom_pad_post: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    tel_pad_post: { regex: /^\d{8,8}$/, isValid: true },
    nom_mad_post: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    tel_mad_post: { regex: /^\d{8,8}$/, isValid: true },
  };

  const [isValid, setIsValid] = useState({
    nombre_post: true,
    apellido_post: true,
    ci_bec_post: true,
    carr_post: true,
    instsup_post: true,
    dirinst_post: true,
    depainst_post: true,
    nom_pad_post: true,
    tel_pad_post: true,
    nom_mad_post: true,
    tel_mad_post: true,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuarioSeleccionado((prevState) => ({ ...prevState, [name]: value }));

    if (validation[name]) {
      const isValidValue = validation[name].regex.test(value);
      setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
    } else {
      // Puedes decidir qué hacer si validation[name] no existe
      // Por ejemplo, marcar como válido o inválido, o simplemente ignorar
      setIsValid((prevState) => ({ ...prevState, [name]: true }));
    }
  };
  ///Modales
  const abrirCerrarModalInsertar = () => {
    setModalInsertar(!modalInsertar);
  };

  const abrirCerrarModalEditar = () => {
    setModalEditar(!modalEditar);
  };

  const abrirCerrarModalVerPerfil = () => {
    setModalOpen(!modalOpen);
  };

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  ////Datos usuario Administrador
  const [dataAdm, setDataAdm] = useState({});
  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfoAdm&id=${adminId}`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setDataAdm(receivedData);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error al cargar los datos.",
        footer: `Código de error: ${error.response.status}`,
      });
    }
  };
  /////Listado postulantes
  const peticionGet = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getPost`);
      const receivedData =
        res.data.Postulantes && Array.isArray(res.data.Postulantes)
          ? res.data.Postulantes
          : [];
      console.log(receivedData);
      setTablaUsuarios(receivedData);
      setDataP(receivedData);
    } catch (error) {
      console.error(error);
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };
  /////Crear Usuario Postulante
  async function peticionPost(e) {
    e.preventDefault();
    let fd = new FormData();
    fd.append("nombre_post", usuarioSeleccionado.nombre_post);
    fd.append("apellido_post", usuarioSeleccionado.apellido_post);
    fd.append("ci_bec_post", usuarioSeleccionado.ci_bec_post);
    fd.append("carr_post", usuarioSeleccionado.carr_post);
    fd.append("instsup_post", usuarioSeleccionado.instsup_post);
    fd.append("dirinst_post", usuarioSeleccionado.dirinst_post);
    fd.append("depainst_post", usuarioSeleccionado.depainst_post);
    fd.append("tipinst_post", usuarioSeleccionado.tipinst_post);
    fd.append("nom_pad_post", usuarioSeleccionado.nom_pad_post);
    fd.append("tel_pad_post", usuarioSeleccionado.tel_pad_post);
    fd.append("nom_mad_post", usuarioSeleccionado.nom_mad_post);
    fd.append("tel_mad_post", usuarioSeleccionado.tel_mad_post);

    // Acceder directamente a la primera posición del array
    if (Array.isArray(dataAdm) && dataAdm.length > 0 && dataAdm[0].id_adm) {
      const idAdm = dataAdm[0].id_adm;
      fd.append("usu_creacion", idAdm);
    } else {
      console.error("No se encontró id_adm");
      return; // Detener envío si no hay id_adm
    }

    try {
      // const res =
      await axios.post(`${baseUrl}?action=addPost`, fd);
      // console.log(res.data);
      mostrarAlertaN();
      peticionGet();
      abrirCerrarModalInsertar();
    } catch (error) {
      console.log(error.response?.data || error);
      mostrarAlertaError();
    }
  }
  /////Modificar Usuario administrativo
  const peticionPut = async () => {
    // Verifica que dataAdm tiene datos
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para modificar");
      return; // O maneja el error de otra forma
    }

    const dataToSend = {
      nombre_post: usuarioSeleccionado.nombre_post,
      apellido_post: usuarioSeleccionado.apellido_post,
      ci_bec_post: usuarioSeleccionado.ci_bec_post,
      carr_post: usuarioSeleccionado.carr_post,
      instsup_post: usuarioSeleccionado.instsup_post,
      dirinst_post: usuarioSeleccionado.dirinst_post,
      depainst_post: usuarioSeleccionado.depainst_post,
      tipinst_post: usuarioSeleccionado.tipinst_post,
      nom_pad_post: usuarioSeleccionado.nom_pad_post,
      tel_pad_post: usuarioSeleccionado.tel_pad_post,
      nom_mad_post: usuarioSeleccionado.nom_mad_post,
      tel_mad_post: usuarioSeleccionado.tel_mad_post,
      usu_modificacion: idAdm,
    };
    // console.log("ci_bec_post:", usuarioSeleccionado.ci_bec_post);
    // console.log("Datos a enviar:", dataToSend);
    try {
      // const response =
      await axios.put(`${baseUrl}?action=updatePost`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log(response.data);

      // Actualizar datos en local si es necesario
      const dataNueva = [...dataP];
      dataNueva.forEach((Usuario) => {
        if (Usuario.ci_bec_post === usuarioSeleccionado.ci_bec_post) {
          Usuario.nombre_post = usuarioSeleccionado.nombre_post;
          Usuario.apellido_post = usuarioSeleccionado.apellido_post;
          Usuario.carr_post = usuarioSeleccionado.carr_post;
          Usuario.instsup_post = usuarioSeleccionado.instsup_post;
          Usuario.dirinst_post = usuarioSeleccionado.dirinst_post;
          Usuario.depainst_post = usuarioSeleccionado.depainst_post;
          Usuario.tipinst_post = usuarioSeleccionado.tipinst_post;
          Usuario.nom_pad_post = usuarioSeleccionado.nom_pad_post;
          Usuario.tel_pad_post = usuarioSeleccionado.tel_pad_post;
          Usuario.nom_mad_post = usuarioSeleccionado.nom_mad_post;
          Usuario.tel_mad_post = usuarioSeleccionado.tel_mad_post;
        }
      });
      setDataP(dataNueva);
      mostrarAlertaU();
      peticionGet();
      abrirCerrarModalEditar();
    } catch (error) {
      console.error("Error en peticionPut:", error);
    }
  };
  /////Eliminar Usuario becario
  async function peticionDelete(ci_bec_post) {
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para eliminar");
      return;
    }

    try {
      // const res =
      await axios.delete(
        `${baseUrl}?action=deletePost&ci_bec_post=${ci_bec_post}&usu_modificacion=${idAdm}`,
      );
      abrirCerrarModalEliminar();
      peticionGet();
      mostrarAlertaD();
      // console.log(res.data);
    } catch (error) {
      console.error("Error en peticionDelete:", error);
    }
  }
  ///descargar archivo
  const descargarArchivoBase64 = (base64Data, filename, mimeType) => {
    try {
      // Si la cadena base64 tiene encabezado "data:...;base64,", elimínalo
      const cleanBase64 = base64Data.replace(/^data:.*;base64,/, "");

      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error al descargar el archivo:", err);
    }
  };
  ////
  const seleccionarUsuario = (Usuario, caso) => {
    setUsuarioSeleccionado(Usuario);
    // console.log("Usuario seleccionado:", Usuario);
    switch (caso) {
      case "Editar":
        abrirCerrarModalEditar();
        break;
      case "Eliminar":
        abrirCerrarModalEliminar();
        break;
      case "Perfil":
        abrirCerrarModalVerPerfil();
        break;
      default:
        console.warn("Caso no reconocido:", caso);
    }
  };

  useEffect(() => {
    peticionGet();
    peticionGetAdm();
  }, []);
  ////BARRA BUSQUEDA
  const [busqueda, setBusqueda] = useState("");
  const [tablaUsuarios, setTablaUsuarios] = useState([]);

  const handleChangeB = (e) => {
    setBusqueda(e.target.value);
    filtrar(e.target.value);
  };

  const filtrar = (terminoBusqueda) => {
    const lowerCaseTerm = terminoBusqueda.toLowerCase();
    const resultadosBusqueda = tablaUsuarios.filter((elemento) => {
      const {
        nombre_post,
        apellido_post,
        carr_post,
        instsup_post,
        ci_bec_post,
      } = elemento;
      return (
        nombre_post.toLowerCase().includes(lowerCaseTerm) ||
        apellido_post.toLowerCase().includes(lowerCaseTerm) ||
        carr_post.toString().toLowerCase().includes(lowerCaseTerm) ||
        ci_bec_post.toString().toLowerCase().includes(lowerCaseTerm) ||
        instsup_post.toString().toLowerCase().includes(lowerCaseTerm)
      );
    });
    setDataP(resultadosBusqueda);
  };
  ////ALERTAS
  const mostrarAlertaN = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Nuevo usuario registrado correctamente.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaError = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "No se pudo registrar.",
      timer: 5000,
      icon: "danger",
    });
  };
  const mostrarAlertaU = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Usuario Modificado.",
      timer: 5000,
      icon: "info",
    });
  };
  const mostrarAlertaD = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Eliminado!",
      text: "Usuario Eliminado.",
      timer: 5000,
      icon: "success",
    });
  };
  //////Filtrar columnas
  const [sortField, setSortField] = useState(null);
  const [order, setOrder] = useState("asc");

  const handleSortingChange = (accessor) => {
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
  };

  const sortedData = dataP.sort((a, b) => {
    if (a[sortField] < b[sortField]) {
      return order === "asc" ? -1 : 1;
    }
    if (a[sortField] > b[sortField]) {
      return order === "asc" ? 1 : -1;
    }
    return 0;
  });

  ///GENERAR PDF INFORME
  const generatePDF = () => {
    // Crear un nuevo documento PDF en orientación horizontal (landscape)
    const doc = new jsPDF({ orientation: "landscape" });

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Reporte Listado Postulantes",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "postulantes, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Listado Postulantes";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Administrador Sistema";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    // Definir los datos de la tabla
    const userData = dataP
      .map((iteb) => ({
        nom_post: `${iteb.nombre_post} ${iteb.apellido_post}`,
        carr_post: iteb.carr_post,
        instsup_post: iteb.instsup_post,
        dirinst_post: iteb.dirinst_post,
        ci_bec_post: iteb.ci_bec_post,
        nom_pad_post: iteb.nom_pad_post,
        tel_pad_post: iteb.tel_pad_post,
        nom_mad_post: iteb.nom_mad_post,
        tel_mad_post: iteb.tel_mad_post,
      }))
      .sort((a, b) => a.nom_post.localeCompare(b.nom_post)) // Ordenar por nombre en orden alfabético ascendente
      .map((iteb, nb) => ({
        it: nb + 1, // Asignar el índice de forma ascendente después de ordenar
        ...iteb, // Desestructurar el resto de las propiedades
      }));

    // Definir las columnas de la tabla
    const columns = [
      { header: "N°", dataKey: "it" },
      { header: "Nombre(s) y Apellido(s)", dataKey: "nom_post" },
      { header: "Carrera", dataKey: "carr_post" },
      { header: "N. Institución", dataKey: "instsup_post" },
      { header: "D. Institución", dataKey: "dirinst_post" },
      { header: "CI Identidad", dataKey: "ci_bec_post" },
      { header: "Nombre padre", dataKey: "nom_pad_post" },
      { header: "Cel/tel padre", dataKey: "tel_pad_post" },
      { header: "Nombre madre", dataKey: "nom_mad_post" },
      { header: "Cel/tel madre", dataKey: "tel_mad_post" },
    ];

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar la tabla al documento PDF
    autoTable(doc, {
      columns: columns,
      body: userData,
      startY: 40,
      margin: { top: 20, bottom: 20 },
      styles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10,
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };
  // ==========================
  // Función para generar el PDF
  // ==========================
  const generatePDFPerfil = (usuario) => {
    const doc = new jsPDF({ orientation: "portrait" });
    const pageWidth = doc.internal.pageSize.getWidth();

    // Función para verificar espacio y agregar página si es necesario
    const ensureSpace = (doc, currentY, spaceNeeded) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginBottom = 20; // margen inferior
      if (currentY + spaceNeeded > pageHeight - marginBottom) {
        doc.addPage();
        return 20; // posición inicial en la nueva página
      }
      return currentY;
    };

    // Propiedades del documento
    doc.setProperties({
      title: " Formulario de Solicitud de Beca",
      author: "BQEF",
      subject: "Formulario de datos",
      keywords: "postulante, formulario, datos",
      creator: "jsPDF",
    });

    const logoWidth = 30;
    const logoHeight = 30;
    const marginTop = 10;

    // Imagen izquierda
    if (logos2) {
      doc.addImage(logos2, "JPEG", 10, marginTop + 5, logoWidth, logoHeight);
    }

    const margin2Top = 35;
    const x = pageWidth - logoWidth - 10;
    const y = margin2Top;
    const borderMargin = 2;
    doc.setLineWidth(0.5);
    doc.setDrawColor(0, 0, 0);
    doc.rect(
      x - borderMargin,
      y - borderMargin,
      logoWidth + 2 * borderMargin,
      logoHeight + 2 * borderMargin,
    );
    // Imagen en el borde
    doc.addImage(imageUrl, "PNG", x, y, logoWidth, logoHeight);

    // Título centrado
    const mainTitle = "Fundación Cuáquera para la Educación en Bolivia";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    const titleWidth = doc.getTextWidth(mainTitle);
    const titleX = (pageWidth - titleWidth) / 2;
    const titleY = marginTop + logoHeight / 2 + 4;

    // Añadir título
    doc.text(mainTitle, titleX, titleY);

    // Línea debajo del título
    doc.setLineWidth(0.5);
    doc.line(titleX, titleY + 1, titleX + titleWidth, titleY + 1);

    // Subtítulo "Programa de Becas 2013"
    const subTitle1 = "Programa de Becas 2013";
    const subTitle1Size = 12;
    doc.setFontSize(subTitle1Size);
    const subTitle1Width = doc.getTextWidth(subTitle1);
    const subTitle1X = (pageWidth - subTitle1Width) / 2;
    const subTitle1Y = titleY + 7;

    // Añadir subtítulo
    doc.text(subTitle1, subTitle1X, subTitle1Y);
    // Línea subrayada
    doc.setLineWidth(0.5);
    doc.line(
      subTitle1X,
      subTitle1Y + 1,
      subTitle1X + subTitle1Width,
      subTitle1Y + 1,
    );

    // Segundo subtítulo "Formulario de Solicitud de Beca"
    const subTitle2 = "Formulario de Solicitud de Beca";
    const subTitle2Size = 12;
    doc.setFontSize(subTitle2Size);
    const subTitle2Width = doc.getTextWidth(subTitle2);
    const subTitle2X = (pageWidth - subTitle2Width) / 2;
    const subTitle2Y = subTitle1Y + 15;

    // Añadir segundo subtítulo
    doc.text(subTitle2, subTitle2X, subTitle2Y);

    // Fecha en esquina superior izquierda
    const fecha = new Date();
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const año = fecha.getFullYear();
    const fechaTexto = `Fecha: ${dia}/${mes}/${año}`;

    const fechaX = marginTop;
    const fechaY = marginTop + 4;
    doc.setFontSize(9);
    doc.text(fechaTexto, fechaX, fechaY);

    // Control de posición vertical
    let currentY = subTitle2Y + 15;

    // Función para agregar secciones con título y tabla
    const addSection = (subtitle, data) => {
      currentY = ensureSpace(doc, currentY, 20);
      // Si se agregó página, reiniciar currentY a posición inicial
      if (currentY === 20) {
        // Opcional: agregar un pequeño margen
      }
      // Añadir título
      doc.setFontSize(10);
      doc.setFont("Helvetica", "bold");
      currentY = Math.max(ensureSpace(doc, currentY, 20), currentY);
      doc.text(subtitle, 10, currentY);
      currentY += 4;

      // Añadir tabla
      const startY = currentY;
      autoTable(doc, {
        startY: startY,
        head: [["Descripción", "Dato", "Descripción", "Dato"]],
        body: data.map((row) => [row.campo, row.valor, row.info3, row.info4]),
        styles: { fontSize: 10 },
        headStyles: { fillColor: [10, 49, 67] },
        margin: { left: 10, right: 10 },
      });
      currentY = doc.lastAutoTable.finalY + 4;
    };

    // Función para agregar preguntas y respuestas
    function addQuestionsAndAnswers(doc, startY, questions) {
      const lineHeight = 8;
      const maxWidth = 180;
      let currentY = startY;

      const ensureSpaceQA = (currentY, spaceNeeded) => {
        const pageHeight = doc.internal.pageSize.getHeight();
        const marginBottom = 10;
        if (currentY + spaceNeeded > pageHeight - marginBottom) {
          doc.addPage();
          currentY = 20; // posición inicial en nueva página
        }
        return currentY;
      };

      questions.forEach((item) => {
        const questionText = String(item.pregunta || "");
        const answerText = String(item.respuesta || "");

        const questionLines = doc.splitTextToSize(questionText, maxWidth);
        const answerLines = doc.splitTextToSize(answerText, maxWidth);

        const totalQuestionHeight = questionLines.length * lineHeight;
        const totalAnswerHeight = answerLines.length * lineHeight;

        currentY = ensureSpaceQA(
          currentY,
          totalQuestionHeight + totalAnswerHeight + 4,
        );

        // Escribir pregunta
        doc.setFontSize(10);
        doc.setFont("Helvetica", "bold");
        questionLines.forEach((line) => {
          doc.text(line, 10, currentY);
          currentY += lineHeight;
        });

        // Escribir respuesta
        doc.setFontSize(10);
        doc.setFont("Helvetica", "normal");
        answerLines.forEach((line) => {
          doc.text(line, 10, currentY);
          currentY += lineHeight;
        });

        currentY += 4; // espacio extra
      });
    }

    // Datos de ejemplo
    const {
      nombre_post,
      apellido_post,
      ci_bec_post,
      reg_estud_post,
      instsup_post,
      fac_inst_post,
      dirinst_post,
      totsemanio_post,
      semanioing_post,
      tipinst_post,
      tipcarr_post,
      depainst_post,
      provinst_post,
      locainst_post,
      carr_post,
      semcurs_post,
      nom_pad_post,
      ci_pad_post,
      tel_pad_post,
      ciu_pad_post,
      prov_pad_post,
      loc_pad_post,
      ocu_pad_post,
      nom_mad_post,
      ci_mad_post,
      tel_mad_post,
      ciu_mad_post,
      prov_mad_post,
      loc_mad_post,
      ocu_mad_post,
      bec_sino_post,
      tipo_bec_post,
      lug_bec_post,
      preg_cinco_post,
      preg_seis_post,
      preg_siete_post,
      preg_ocho_post,
      preg_nueve_post,
      preg_diez_post,
      lug_post,
      fec_post,
    } = usuario;

    const datosPersonales = [
      {
        campo: "Apellido(s):",
        valor: `${apellido_post}`,
        info3: "Nombre(s):",
        info4: `${nombre_post}`,
      },
      { campo: "CI:", valor: ci_bec_post, info3: "", info4: "" },
    ];

    const datosCentroEstudios = [
      {
        campo: "N° Registro Estudiante:",
        valor: reg_estud_post,
        info3: "Centro de Estudio:",
        info4: instsup_post,
      },
      {
        campo: "Facultad:",
        valor: fac_inst_post,
        info3: "Carrera:",
        info4: carr_post,
      },
      {
        campo: "Tipo de centro:",
        valor: tipinst_post,
        info3: "Tipo de carrera:",
        info4: tipcarr_post,
      },
      {
        campo: "Departamento:",
        valor: depainst_post,
        info3: "Provincia:",
        info4: provinst_post,
      },
      {
        campo: "Localidad:",
        valor: locainst_post,
        info3: "Dirección (Zona/Calle/N°):",
        info4: dirinst_post,
      },
      {
        campo: "Semestres de la carrera:",
        valor: totsemanio_post,
        info3: "Semestre ingreso:",
        info4: semanioing_post,
      },
      {
        campo: "Último semestre vencido:",
        valor: semcurs_post,
        info3: "",
        info4: "",
      },
    ];

    const datosPadres = [
      {
        campo: "Apellido(s) y nombre(s) del padre:",
        valor: nom_pad_post,
        info3: "CI:",
        info4: ci_pad_post,
      },
      {
        campo: "Teléfono/Celular:",
        valor: tel_pad_post,
        info3: "Ciudad proced.:",
        info4: ciu_pad_post,
      },
      {
        campo: "Provincia:",
        valor: prov_pad_post,
        info3: "Localidad:",
        info4: loc_pad_post,
      },
      {
        campo: "Ocupación actual(explique brevemente):",
        valor: ocu_pad_post,
        info3: "",
        info4: "",
      },
      {
        campo: "Apellido(s) y nombre(s) de la madre:",
        valor: nom_mad_post,
        info3: "CI:",
        info4: ci_mad_post,
      },
      {
        campo: "Teléfono/Celular:",
        valor: tel_mad_post,
        info3: "Ciudad proced.:",
        info4: ciu_mad_post,
      },
      {
        campo: "Provincia:",
        valor: prov_mad_post,
        info3: "Localidad:",
        info4: loc_mad_post,
      },
      {
        campo: "Ocupación actual(explique brevemente):",
        valor: ocu_mad_post,
        info3: "",
        info4: "",
      },
    ];

    const datosBeca = [
      {
        campo: "Si/No:",
        valor: bec_sino_post,
        info3: "Tipo de beca:",
        info4: tipo_bec_post,
      },
      { campo: "Lugar:", valor: lug_bec_post, info3: "", info4: "" },
    ];

    // Agregar secciones
    currentY = ensureSpace(doc, currentY, 20);
    addSection(" 1.- Datos Personales", datosPersonales);

    currentY = ensureSpace(doc, currentY, 20);
    addSection(" 2.- Datos Centro de Estudios", datosCentroEstudios);

    currentY = ensureSpace(doc, currentY, 20);
    addSection(" 3.- Datos Padres", datosPadres);

    currentY = ensureSpace(doc, currentY, 20);
    addSection(" 4.- Obtuvo Alguna Beca Anteriormente", datosBeca);

    // Preguntas y respuestas
    const startY = ensureSpace(doc, currentY, 20);
    addQuestionsAndAnswers(doc, startY, [
      {
        pregunta:
          "5.- ¿Por qué solicita usted la Beca a la Fundación Quakera para la Educación en Bolivia? (Detallar)",
        respuesta: "R: " + preg_cinco_post,
      },
      {
        pregunta: "6.- ¿Quién cubre sus gastos de estudio, actualmente?",
        respuesta: "R: " + preg_seis_post,
      },
      {
        pregunta:
          "7.- ¿Cuáles son tus gastos específicos que tú no puedes cubrir en tu estudio?",
        respuesta: "R: " + preg_siete_post,
      },
      {
        pregunta:
          "8.- ¿Cuál es tu presupuesto mensual de gastos en tu estudio? Detallar los gastos",
        respuesta: "R: " + preg_ocho_post,
      },
      {
        pregunta:
          "9.- ¿Cuáles serían sus obligaciones en caso de ser aceptado como Becario/a de esta Institución?",
        respuesta: "R: " + preg_nueve_post,
      },
      {
        pregunta:
          "10.-  En Bolivian Quaker Education BQE-Bo, sostenido mediante sus valores, creemos que todos podemos apoyar al prójimo para ayudar a otros que también necesitan vivir bien. Se usted recibe ayuda de esta Institución. ¿Qué piensas hacer cuando ya seas profesional y estés trabajando para ayudar a otros necesitados, a cambio de la ayuda que podías recibir de BQE-Bo?",
        respuesta: "R: " + preg_diez_post,
      },
      {
        pregunta: "Lugar y fecha de postulación:",
        respuesta: lug_post + ", " + fec_post,
      },
    ]);
    currentY = doc.lastAutoTable.finalY + 8;

    // Número de páginas
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.getHeight() - 10,
      );
    }

    // Mostrar en ventana
    const pdfBlob = doc.output("blob");
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };
  /////
  const handleVerClick = (usuario) => {
    // console.log("Usuario para generar PDF:", usuario);
    generatePDFPerfil(usuario);
  };
  // Determina la fuente de la imagen
  const imageUrl = usuarioSeleccionado.imagen_post
    ? `data:image/png;base64,${usuarioSeleccionado.imagen_post}` // Si hay datos en usuarioSeleccionado.foto, úsalos como Base64
    : DefaultProfileImage; // Si no, usa la imagen por defecto importada
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Listado Postulantes</h2>
        </div>
        <div className="frm">
          <Button
            color="success"
            size="lg"
            onClick={() => abrirCerrarModalInsertar()}
          >
            <FaIcons.FaPlus /> Añadir
          </Button>
          &nbsp;&nbsp;
          <Button color="primary" size="lg" onClick={generatePDF}>
            <FaIcons.FaFileDownload /> Reporte
          </Button>
        </div>
        <div className="frm containerInput">
          <Input
            className="form-control inputBuscar"
            bsSize="lg"
            value={busqueda}
            placeholder="Búsqueda por Nombre, Apellido o Email"
            onChange={handleChangeB}
          />
          <Button className="btn btn-success" size="lg">
            <FaIcons.FaSearch /> Buscar
          </Button>
        </div>
        <Table className="frm" responsive="sm" id="tabl">
          <thead id="stahead">
            <tr className="text-center">
              <th>N°</th>
              <th>
                <span onClick={() => handleSortingChange("nombre_post")}>
                  Nombres
                  {sortField === "nombre_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "nombre_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("apellido_post")}>
                  Apellidos
                  {sortField === "apellido_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "apellido_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("email_post")}>
                  Correo
                  {sortField === "email_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "email_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("cel_bec_post")}>
                  Celular
                  {sortField === "cel_bec_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "cel_bec_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              {/* <th>
                <span onClick={() => handleSortingChange("carr_post")}>
                  Carrera
                  {sortField === "carr_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "carr_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th> */}
              {/* <th>
                <span onClick={() => handleSortingChange("instsup_post")}>
                  N. Institución
                  {sortField === "instsup_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "instsup_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th> */}
              {/* <th>
                <span onClick={() => handleSortingChange("dirinst_post")}>
                  D. Institución
                  {sortField === "dirinst_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "dirinst_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th> */}
              <th>
                <span onClick={() => handleSortingChange("ci_bec_post")}>
                  CI Identidad
                  {sortField === "ci_bec_post" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "ci_bec_post" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((Usuario, index) => (
              <tr className="text-center" key={Usuario.id}>
                <td>{index + 1}</td>
                <td>{Usuario.nombre_post}</td>
                <td>{Usuario.apellido_post}</td>
                <td>{Usuario.email_post}</td>
                <td>{Usuario.cel_bec_post}</td>
                {/* <td>{Usuario.carr_post}</td> */}
                {/* <td>{Usuario.instsup_post}</td>
                <td>{Usuario.dirinst_post}</td> */}
                <td>{Usuario.ci_bec_post}</td>
                <td>
                  <Button
                    color="danger"
                    outline
                    onClick={() =>
                      descargarArchivoBase64(
                        Usuario.archivo_pdf,
                        "Requisitos.pdf",
                        "application/pdf",
                      )
                    }
                  >
                    PDF
                  </Button>
                  {"  "}
                  <Button
                    color="success"
                    outline
                    onClick={() =>
                      descargarArchivoBase64(
                        Usuario.archivo_otro,
                        "Formularios 2026.xls",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      )
                    }
                  >
                    Excel
                  </Button>
                  {/* <Button
                    color="primary"
                    onClick={() => seleccionarUsuario(Usuario, "Perfil")}
                  >
                    Ver Datos
                  </Button>{" "} */}
                  {"  "}
                  <Button
                    color="warning"
                    onClick={() => seleccionarUsuario(Usuario, "Editar")}
                  >
                    Editar
                  </Button>{" "}
                  {"  "}
                  <Button
                    color="danger"
                    onClick={() => seleccionarUsuario(Usuario, "Eliminar")}
                  >
                    Eliminar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* El Modal REPORTE */}
        <Modal isOpen={modalOpen} toggle={abrirCerrarModalVerPerfil} size="lg">
          {" "}
          {/* size="lg" para un modal más grande */}
          <ModalHeader className="header_mo">Perfil de Usuario</ModalHeader>
          <ModalBody>
            <Container>
              <Row className="align-items-center">
                {" "}
                {/* Centrar verticalmente */}
                <Col md="4" className="text-center">
                  {/* Foto de Perfil - Usa usuarioSeleccionado.foto */}
                  <img
                    src={imageUrl} // Usa la fuente determinada
                    alt="Foto de Perfil"
                    className="rounded-circle"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }} // Estilo para tamaño y ajuste
                  />
                </Col>
                <Col md="8">
                  {/* Datos Principales */}
                  <h5>
                    <strong>Nombre Completo:</strong>{" "}
                    {usuarioSeleccionado.nombre_post}{" "}
                    {usuarioSeleccionado.apellido_post}
                    <br />
                    <strong>CI Identidad:</strong>{" "}
                    {usuarioSeleccionado.ci_bec_post}
                    <br />
                    <strong>Nombre Institución:</strong>{" "}
                    {usuarioSeleccionado.instsup_post}
                    <br />
                    <strong>Dirección Institución:</strong>{" "}
                    {usuarioSeleccionado.dirinst_post}
                    <br />
                    <strong>Ciudad Institución:</strong>{" "}
                    {usuarioSeleccionado.depainst_post}
                    <br />
                    <strong>Carrera:</strong> {usuarioSeleccionado.carr_post}
                    <br />
                    <strong>Tipo Institución:</strong>{" "}
                    {usuarioSeleccionado.tipinst_post}
                    <br />
                    <strong>Nombre Padre:</strong>{" "}
                    {usuarioSeleccionado.nom_pad_post}
                    <br />
                    <strong>Celular Padre:</strong>{" "}
                    {usuarioSeleccionado.tel_pad_post}
                    <br />
                    <strong>Nombre Madre:</strong>{" "}
                    {usuarioSeleccionado.nom_mad_post}
                    <br />
                    <strong>Celular Madre:</strong>{" "}
                    {usuarioSeleccionado.tel_mad_post}
                  </h5>
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => handleVerClick(usuarioSeleccionado)}
            >
              Ver Completo
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalVerPerfil()}
            >
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal añadir postulante */}
        <Modal isOpen={modalInsertar} toggle={abrirCerrarModalInsertar}>
          <ModalHeader className="header_mo">Insertar Postulante</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nombres: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre_post"
                  value={usuarioSeleccionado.nombre_post}
                  onChange={handleChange}
                />
                {!isValid.nombre_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Apellidos: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido_post"
                  value={usuarioSeleccionado.apellido_post}
                  onChange={handleChange}
                />
                {!isValid.apellido_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>CI Identidad: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="ci_bec_post"
                  value={usuarioSeleccionado.ci_bec_post}
                  onChange={handleChange}
                />{" "}
                {!isValid.ci_bec_post && (
                  <span style={{ color: "red" }}>Formato no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Carrera: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="carr_post"
                  value={usuarioSeleccionado.carr_post}
                  onChange={handleChange}
                />
                {!isValid.carr_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 30 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>N. Institución: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="instsup_post"
                  value={usuarioSeleccionado.instsup_post}
                  onChange={handleChange}
                />
                {!isValid.instsup_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 30 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Dir. Institución: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="dirinst_post"
                  value={usuarioSeleccionado.dirinst_post}
                  onChange={handleChange}
                />
                {!isValid.dirinst_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 50 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Ciudad Institución: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="depainst_post"
                  value={usuarioSeleccionado.depainst_post}
                  onChange={handleChange}
                />
                {!isValid.depainst_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Tipo Institución: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="tipinst_post"
                  value={usuarioSeleccionado.tipinst_post}
                  onChange={handleChange}
                >
                  <option value="">Seleccione una opción</option>
                  <option value="Público">Público</option>
                  <option value="Privado">Privado</option>
                  <option value="Convenio">Convenio</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Nombre Padre: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nom_pad_post"
                  value={usuarioSeleccionado.nom_pad_post}
                  onChange={handleChange}
                />
                {!isValid.nom_pad_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular Padre: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="tel_pad_post"
                  value={usuarioSeleccionado.tel_pad_post}
                  onChange={handleChange}
                />
                {!isValid.tel_pad_post && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Nombre Madre: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nom_mad_post"
                  value={usuarioSeleccionado.nom_mad_post}
                  onChange={handleChange}
                />
                {!isValid.nom_mad_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular Madre: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="tel_mad_post"
                  value={usuarioSeleccionado.tel_mad_post}
                  onChange={handleChange}
                />
                {!isValid.tel_mad_post && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={(e) => peticionPost(e)}
              disabled={
                !isValid.nombre_post ||
                !isValid.apellido_post ||
                !isValid.ci_bec_post ||
                !isValid.carr_post ||
                !isValid.instsup_post ||
                !isValid.dirinst_post ||
                !isValid.depainst_post ||
                !isValid.nom_pad_post ||
                !isValid.tel_pad_post ||
                !isValid.nom_mad_post ||
                !isValid.tel_mad_post
              }
            >
              Guardar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalInsertar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Editar */}
        <Modal isOpen={modalEditar} toggle={abrirCerrarModalEditar}>
          <ModalHeader className="header_mo">Editar Usuario</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nombres: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre_post"
                  onChange={handleChange}
                  value={usuarioSeleccionado && usuarioSeleccionado.nombre_post}
                />
                {!isValid.nombre_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Apellidos: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.apellido_post
                  }
                  onChange={handleChange}
                />
                {!isValid.apellido_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>CI Identidad: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="ci_bec_post"
                  value={usuarioSeleccionado && usuarioSeleccionado.ci_bec_post}
                  onChange={handleChange}
                />{" "}
                {!isValid.ci_bec_post && (
                  <span style={{ color: "red" }}>Formato no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Carrera: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="carr_post"
                  value={usuarioSeleccionado && usuarioSeleccionado.carr_post}
                  onChange={handleChange}
                />
                {!isValid.carr_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 30 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>N. Institución: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="instsup_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.instsup_post
                  }
                  onChange={handleChange}
                />
                {!isValid.instsup_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 30 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Dir. Institución: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="dirinst_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.dirinst_post
                  }
                  onChange={handleChange}
                />
                {!isValid.dirinst_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 50 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Ciudad Institución: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="depainst_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.depainst_post
                  }
                  onChange={handleChange}
                />
                {!isValid.depainst_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Tipo Institución: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="tipinst_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.tipinst_post
                  }
                  onChange={handleChange}
                >
                  <option value="">Seleccione una opción</option>
                  <option value="Público">Público</option>
                  <option value="Privado">Privado</option>
                  <option value="Convenio">Convenio</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Nombre Padre: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nom_pad_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.nom_pad_post
                  }
                  onChange={handleChange}
                />
                {!isValid.nom_pad_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular Padre: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="tel_pad_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.tel_pad_post
                  }
                  onChange={handleChange}
                />
                {!isValid.tel_pad_post && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Nombre Madre: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nom_mad_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.nom_mad_post
                  }
                  onChange={handleChange}
                />
                {!isValid.nom_mad_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular Madre: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="tel_mad_post"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.tel_mad_post
                  }
                  onChange={handleChange}
                />
                {!isValid.tel_mad_post && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => peticionPut()}
              disabled={
                !isValid.nombre_post ||
                !isValid.apellido_post ||
                !isValid.ci_bec_post ||
                !isValid.carr_post ||
                !isValid.instsup_post ||
                !isValid.dirinst_post ||
                !isValid.depainst_post ||
                !isValid.nom_pad_post ||
                !isValid.tel_pad_post ||
                !isValid.nom_mad_post ||
                !isValid.tel_mad_post
              }
            >
              Modificar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEditar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Eliminar */}
        <Modal isOpen={modalEliminar} toggle={abrirCerrarModalEliminar}>
          <ModalHeader className="header_mo">Eliminar Postulante</ModalHeader>
          <ModalBody>
            ¿Estás seguro que deseas eliminar el Postulante{" "}
            {usuarioSeleccionado &&
              usuarioSeleccionado.nombre_post +
                " " +
                usuarioSeleccionado.apellido_post}
            ?
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => peticionDelete(usuarioSeleccionado.ci_bec_post)}
            >
              Sí
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEliminar()}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

export default ListUserPost;
